import { useState, createContext, useEffect, useRef } from "react";
import { cookieGetter } from "../helpers/cookieGetter";

export const Context = createContext();

const Provider = ({ children }) => {
    const [locale, setLocale] = useState("en");
    const [secondaryEmail, setSecondaryEmail] = useState("");
    const [cancelRedirectUrl, setCancelRedirectUrl] = useState("");
    const [isLogoutInProgress, setIsLogoutInProgress] = useState(false);
    const { user_lang } = cookieGetter();
    const initRender = useRef(true);

    useEffect(() => {
        if (initRender.current) {
            if (sessionStorage.getItem("locale")) {
                return setLocale(sessionStorage.getItem("locale"));
            } else {
                if (user_lang) {
                    sessionStorage.setItem("locale", user_lang);
                    return setLocale(user_lang);
                }
            }
        }
        sessionStorage.setItem("locale", locale);
    }, [locale, user_lang]);

    useEffect(() => {
        initRender.current = false;
    }, []);

    return (
        <Context.Provider
            value={{
                locale,
                setLocale,
                secondaryEmail,
                setSecondaryEmail,
                cancelRedirectUrl,
                setCancelRedirectUrl,
                isLogoutInProgress,
                setIsLogoutInProgress,
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default Provider;
